/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { GroupTypes } from "~/generated/graphql";

export const GROUP_TYPE_LABELS: Record<GroupTypes, string> = {
  [GroupTypes.Manual]: "Manual",
  [GroupTypes.Dynamic]: "Dynamic",
  [GroupTypes.Mixed]: "Dynamic and Manual",
  [GroupTypes.Empty]: "Empty",
};
